<template>
	<div
		data-component="dds-defender-switch-field"
	>
		<label
			data-element="label"
		>
			{{ label }}
		</label>
		<div v-for="position in positions" :key="position.short" data-element="suit-select">
			<span data-element="position-name">
				{{ position.name }}
			</span>
			<select-field
				htmlOptions
				hideSelected
				multiple
				name="suit"
				:hasPlaceholder="false"
				:hasLabel="false"
				:selectLabel="''"
				:deselectLabel="''"
				:showNoOptions="false"
				:options="getCardsOptionsWithText(position.short)"
				:value="getValue(position)"
				@input="handleCardSelection($event, position)"
			/>
		</div>
	</div>
</template>

<script>

	import SelectField from '@/components/forms/SelectField';
	import { createSuitElement } from '@/helpers';
	import { Game } from '@bridge128/bridge128-game-logic-lib';

	export default {
		components: {
			SelectField
		},
		props: {
			deal: {
				type: Object,
				default: undefined
			},
			positions: {
				type: Array,
				required: true,
				default () {
					return [];
				}
			},
			label: {
				type: String,
				default: undefined
			},
			propKey: {
				type: String,
				default: 'ddsPlaysSuitsAfterFirstWin'
			}
		},
		data: () => ({
			suitsDataMap: {
				H: {
					symbol: '♥',
					colour: 'red'
				},
				D: {
					symbol: '♦',
					colour: 'red'
				},
				S: {
					symbol: '♠',
					colour: 'black'
				},
				C: {
					symbol: '♣',
					colour: 'black'
				}
			}
		}),
		computed: {
			getGameData () {
				if (this.deal) {
					return Game.fromState(this.deal.deal);
				}
				return null;
			}
		},
		methods: {
			getValue (position) {
				const valueKey = `${this.propKey}${position.name}`;

				return this.deal[valueKey] || [];
			},
			handleCardSelection (value, position) {
				const valueKey = `${this.propKey}${position.name}`;

				this.$set(this.deal, valueKey, value);
			},
			getCardsOptions (position) {
				if (this.getGameData) {
					const player = this.getGameData[`player${position}`];
					return player.handAsList.map(({ name }) => name);
				}
				return [];
			},
			getCardsOptionsWithText (position) {
				const options = this.getCardsOptions(position);
				return options.map(name => {
					const cardValue = name[0];
					const cardSuit = name[1];
					const suit = this.suitsDataMap[cardSuit];
					const text = `<b>${cardValue}</b> ${createSuitElement(suit.symbol, suit.colour)}`;
					return {
						value: name,
						text
					};
				});
			}
		}
	};

</script>

<style lang="scss" scoped>

	[data-component="dds-defender-switch-field"] {

		[data-element="suit-select"] {
			display: flex;
			align-items: center;
			cursor: pointer;
			margin: rem(18) 0;

			&:not(:last-child) {
				margin-right: rem(20);
			}

			[data-component='select-field'] {
				min-width: 120px;
				margin: 0;
			}
		}

		[data-element="position-name"] {
			display: flex;
			align-items: center;
			font-size: rem(18);
			line-height: 1;
			margin-bottom: 0;
			margin-right: rem(18);
			font-weight: 700;
		}
	}

</style>
